/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Container, Row } from "reactstrap";
import {
  setAllMembers,
  setChats,
  setContacts,
  setGroups,
  setLoading,
  setMemberStatus,
  setStoreChatRequests,
  setStores,
  UpdateBlocked,
  UpdateFriends,
  UpdateRequests,
} from "../../../../ReduxToolkit/Reducers/ChatReducer";
import LeftSidebarChat from "../Common/LeftSidebarChat";
import PrivateChatContent from "./PrivateChatContent";
import { getAPIURL, getUserID, getVendorID } from "../../../../services/helper";
import WebSocketManager from "./SocketManager";
import { useSelector } from "react-redux";
import { RootState } from "../../../../ReduxToolkit/Store";
import Loader from "../../../../Layout/Loader";
import http from "../../../../services/http";

const api_url_aws = process.env.REACT_APP_API_URL_AWS;
const api_url = getAPIURL();
const currentUserId = getUserID();
const vendor_id = getVendorID();

export default function PrivateChatContainer() {
  const { isLoading } = useSelector((state: RootState) => state.chat);
  const dispatch = useDispatch();

  const fetchOnlineUsers = async () => {
    try {
      const response = await axios.get(`${api_url_aws}/chats/online-users`);
      const online_users = response.data.userIds.map((u: string) => Number(u));
      // console.log(online_users);
      dispatch(setMemberStatus(online_users));
    } catch (error) {
      console.error("data not fetched", error);
    }
  };

  const fetchChatGroups = async () => {
    try {
      const response = await axios.get(
        `${api_url_aws}/chats/groups/${currentUserId}`
      );
      // console.log(response);
      dispatch(setGroups(response.data.data));
    } catch (error) {
      console.error("data not fetched", error);
    }
  };

  const fetchChatApiData = async () => {
    try {
      const response = await axios.get(
        `${api_url_aws}/chats/?userId=${currentUserId}`
      );
      // console.log(response);
      dispatch(setChats(response.data.data));
    } catch (error) {
      console.error("data not fetched", error);
    }
  };

  const fetchChatMemberApiData = async () => {
    try {
      const response = await axios.get(`${api_url}/chat-customers`);
      const { success, data: members } = response.data;
      if (success) {
        dispatch(setAllMembers(members));
        fetchOnlineUsers();
      }
    } catch (error) {
      console.error("data not fetched", error);
    }
  };

  const fetchChatFriends = async () => {
    try {
      dispatch(setLoading(true));
      const response = await axios.get(
        `${api_url}/chats/friends/${currentUserId}`
      );
      const { success, data } = response.data;
      if (success) {
        dispatch(UpdateFriends(data.friends_list));
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error("data not fetched", error);
    }
  };
  const fetchFriendRequests = async () => {
    try {
      dispatch(setLoading(true));
      const response = await axios.get(
        `${api_url}/friends/requests/${currentUserId}`
      );
      const { success, data } = response.data;
      if (success) {
        dispatch(UpdateRequests(data.pending_requests));
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error("data not fetched", error);
    }
  };
  const fetchBlocked = async () => {
    try {
      dispatch(setLoading(true));
      const response = await axios.get(
        `${api_url}/chats/block/${currentUserId}`
      );
      const { success, data } = response.data;
      if (success) {
        dispatch(UpdateBlocked(data.block_list));
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error("data not fetched", error);
    }
  };

  const fetchStoreChatRequests = async () => {
    try {
      dispatch(setLoading(true));
      const response = await axios.get(
        `${api_url}/chats/store/request/${vendor_id}`
      );
      const { success, data } = response.data;
      if (success) {
        dispatch(setStoreChatRequests(data));
        dispatch(setLoading(false));
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error("data not fetched", error);
    }
  };

  const fetchStores = async () => {
    try {
      const response = await http.get(`${api_url}/stores`);

      const stores = response.data.data.map((s: any) => ({
        id: s.term_id,
        name: s.name,
        slug: s.slug,
      }));
      dispatch(setStores(stores));
    } catch (error) {
      console.error("data not fetched", error);
    }
  };

  useEffect(() => {
    fetchChatMemberApiData();
    fetchChatApiData();
    fetchChatGroups();
    fetchChatFriends();
    fetchBlocked();
    fetchFriendRequests();
    fetchStores();
    vendor_id && fetchStoreChatRequests();
  }, []);

  return (
    <div className="page-body">
      {isLoading && <Loader />}

      {/* <WebSocketManager /> */}

      <Container fluid>
        <Row className="g-0">
          <LeftSidebarChat />
          <PrivateChatContent />
        </Row>
      </Container>
    </div>
  );
}
